// Global Instructions Rule Applied!
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons'
import { Tooltip } from 'antd'
import { toast } from 'react-toastify'
import Button from '../../Button.jsx'

interface RefreshButtonProps {
  loading: boolean
  onRefresh: () => void
}

const RefreshButton = ({ loading, onRefresh }: RefreshButtonProps) => {
  const handleClick = () => {
    onRefresh()
    toast.success('Files refreshed successfully')
  }

  return (
    <Tooltip title='Refresh files'>
      <Button
        variant='default'
        size='small'
        icon={<FontAwesomeIcon icon={faArrowsRotate} style={{ color: '#9ca3af' }} />}
        style={{ color: '#9ca3af' }}
        loading={loading}
        onClick={handleClick}
      />
    </Tooltip>
  )
}

export default RefreshButton
